import { useFeature } from "byzantine";
import { RecipientDrawer, DRAWER_TYPES } from "../../../RecipientDrawer";
import { RecipientDrawer as NewRecipientDrawer } from "../../../../src/modules/recipientDrawer";

interface DomesticWireRecipientDrawerProps {
  isOpen: boolean;
  recipientId?: API.RecipientId;
  onClose: (recipientId?: API.RecipientId) => void;
}

const DomesticWireRecipientDrawer = ({
  isOpen,
  recipientId,
  onClose,
}: DomesticWireRecipientDrawerProps) => {
  const isNewDrawerEnabled = useFeature().featureEnabled("recipient_drawer");

  if (isNewDrawerEnabled) {
    return (
      <NewRecipientDrawer
        isOpen={isOpen}
        flow="wire"
        onClose={({ recipient }) => onClose(recipient?.id)}
        {...(recipientId ? { mode: "edit", recipientId } : { mode: "create" })}
      />
    );
  }

  return (
    <RecipientDrawer
      handleClose={onClose}
      isOpen={isOpen}
      fromACHFlow={false}
      fromDomesticWireFlow={true}
      recipientId={recipientId}
      drawerType={recipientId ? DRAWER_TYPES.edit : DRAWER_TYPES.add}
    />
  );
};

export default DomesticWireRecipientDrawer;
